export default __webpack_public_path__ + "static/media/callMeConfigure.98b53a4b.svg";